import { useEffect, useState } from 'react';

// Shared loader for Program Insights metric cards: calls `fetcher(filters, { signal })` whenever the
// page filters change, aborting the previous request, and exposes { data, status } where status is
// 'loading' | 'loaded' | 'error'. Keeps every card's fetch lifecycle identical.
export default function useProgramInsightsMetric(fetcher, filters) {
  const [data, setData] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const controller = new AbortController();
    let isCurrent = true;

    setStatus('loading');

    fetcher(filters, { signal: controller.signal })
      .then((response) => {
        if (!isCurrent) return;
        setData(response);
        setStatus('loaded');
      })
      .catch((err) => {
        if (!isCurrent || err?.name === 'AbortError') return;
        setStatus('error');
      });

    return () => {
      isCurrent = false;
      controller.abort();
    };
  }, [fetcher, filters]);

  return { data, status };
}
